import { Component, OnInit, AfterViewInit, Inject, PLATFORM_ID, Input } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import Glide from '@glidejs/glide';


@Component({
  selector: 'app-global-leaders',
  templateUrl: './global-leaders.component.html',
  styleUrls: ['./global-leaders.component.scss']
})
export class GlobalLeadersComponent implements OnInit, AfterViewInit {

  isBrowser = false;
  @Input() title: string = 'Trusted by Global Leaders';
  @Input() clientLogos: any[] = [];

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  defaultClientLogos = [
    {
      src: '../../../../assets/images/plagiarism-check/clients/mit.svg',
      width: 62,
      height: 33,
      alt: 'Massachusetts Institute of Technology (MIT) logo',
      class: 'filter'
    },
    {
      src: '../../../../assets/images/plagiarism-check/clients/IEEE.svg',
      width: 110,
      height: 32,
      alt: 'IEEE logo',
      class: 'filter'
    },
    {
      src: '../../../../assets/images/plagiarism-check/clients/stanford.svg',
      width: 99,
      height: 44,
      alt: 'Stanford University logo',
      class: 'filter'
    },
    {
      src: '../../../../assets/images/plagiarism-check/clients/wiley.svg',
      width: 114,
      height: 28,
      alt: 'Wiley logo',
      class: 'filter'
    },
    {
      src: '../../../../assets/images/plagiarism-check/clients/pfizer.svg',
      width: 118,
      height: 48,
      alt: 'Pfizer logo',
      class: 'filter'
    },
    {
      src: '../../../../assets/images/plagiarism-check/clients/abbott.svg',
      width: 126,
      height: 32,
      alt: 'Abbott logo',
      class: 'filter'
    },
    {
      src: '../../../../assets/images/plagiarism-check/clients/princeton-white.svg',
      width: 132,
      height: 36,
      alt: 'Princeton University logo',
      class: ''
    }
  ];

  ngOnInit() {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (!this.clientLogos || this.clientLogos.length === 0) {
      this.clientLogos = this.defaultClientLogos;
    }
  }

  ngAfterViewInit() {
    if (this.isBrowser) {
      setTimeout(() => {
        new Glide('#leadersSlider', {
          type: 'carousel',
          perView: 7,
          gap: 10,
          autoplay: 3000,
          breakpoints: {
            1024: { perView: 6 },
            768: { perView: 5 },
            480: { perView: 2 }
          }
        }).mount();
      }, 0); // You can increase this if needed
    }
  }

}
